var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPatientList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n                   .st0{fill:currentColor;}\r\n               ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.5,9.9c0.2,2.4,2.2,4.3,4.6,4.3c2.5,0,4.5-1.9,4.6-4.4c0-0.1,0-0.1,0-0.2c0,0,0-0.1,0-0.1                            c0-2.6-2.1-4.6-4.6-4.6S3.4,7,3.4,9.5c0,0,0,0.1,0,0.1C3.4,9.8,3.4,9.8,3.5,9.9z M8.1,12.7c-1.4,0-2.7-1-3.1-2.3                            c1,0,2.5-0.2,3.9-1.2c0.4,0.5,1.2,1.1,2.2,1.2C10.7,11.8,9.5,12.7,8.1,12.7z M8.1,6.3c1.6,0,2.9,1.1,3.1,2.7                            c-0.9-0.1-1.5-1.1-1.5-1.2C9.6,7.6,9.4,7.5,9.2,7.5c-0.2,0-0.4,0-0.6,0.2C7.3,8.8,5.8,9,4.9,9C5.2,7.5,6.5,6.3,8.1,6.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22.3,0h-5.9c-0.9,0-1.7,0.8-1.7,1.7v4.9c0,2.3,1.7,4.2,3.9,4.6v7.2c0,0.7-0.6,1.2-1.2,1.2h-1.2v-0.3                            c0-2-1.6-3.7-3.7-3.7H3.7c-2,0-3.7,1.6-3.7,3.7v3.9C0,23.7,0.3,24,0.7,24h14.7c0.4,0,0.7-0.3,0.7-0.7v-2.2h1.2                            c1.5,0,2.7-1.2,2.7-2.7v-7.2c2.2-0.4,3.9-2.3,3.9-4.6V1.7C24,0.8,23.2,0,22.3,0z M14.7,22.6H1.4v-3.2c0-1.2,1-2.2,2.2-2.2h8.8                            c1.2,0,2.2,1,2.2,2.2V22.6z M22.6,6.6c0,1.8-1.4,3.2-3.2,3.2c-1.8,0-3.2-1.4-3.2-3.2V1.7c0-0.1,0.1-0.3,0.3-0.3h5.9                            c0.1,0,0.3,0.1,0.3,0.3V6.6z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.8,4.6h-1v-1c0-0.3-0.2-0.5-0.5-0.5c-0.3,0-0.5,0.2-0.5,0.5v1h-1c-0.3,0-0.5,0.2-0.5,0.5                        c0,0.3,0.2,0.5,0.5,0.5h1v1c0,0.3,0.2,0.5,0.5,0.5c0.3,0,0.5-0.2,0.5-0.5v-1h1c0.3,0,0.5-0.2,0.5-0.5C21.3,4.9,21.1,4.6,20.8,4.6z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientList);
export default __webpack_public_path__ + "static/media/patientList.02a122af4158c20be6cb29a630b33ab0.svg";
export { ForwardRef as ReactComponent };